export const DISTANCE_BASED_PRICING_TIERS = [ //map trip miles to a tier
    {
        name: 'dbpRateTier1',
        lower: 0,
        upper: 1.5,
    },
    {
        name: 'dbpRateTier2',
        lower: 1.5,
        upper: 3,
    },
    {
        name: 'dbpRateTier3',
        lower: 3,
        upper: 9999,
    },
];